<template>
  <div class="table">
    <div v-if="$_verifyLoadedVuex('done')" class="table__header">
      <div class="table__row">
        <div v-for="item in historySerie" :key="item" :class="['table__column', resolveTextAlign(item)]">
          <div class="table__header-title" v-html="$t(`integrations.import-header.${item}`)"></div>
          <div
            :class="['table__order-by', { 'table__order-by--active': isActive === item }]"
            @click.prevent="ordenate(item)"
          >
            <span :class="['table__dash-arrows', isActive === item ? `table__dash-arrows--${orderType}` : '']"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$_verifyLoadedVuex('done')" class="table__body">
      <div v-for="(item, index) in tableData" :key="index" class="table__row">
        <div class="table__column text-center">
          <div class="table__status-wrapper">
            <div class="table__recurrent">
              <img
                v-show="Boolean(item.recurring)"
                src="@/assets/svgs/Recurrent.svg"
                v-tooltip.top-start="{
                  theme: 'default',
                  content: $t('integrations.recurrence-load'),
                  html: true,
                  distance: 8,
                }"
              />
            </div>
            <div class="table__status-item">
              <span :class="[`table__status table__status--${item.statusKey}`]">
                {{ item.status.toLowerCase() }}
              </span>
            </div>
          </div>
        </div>
        <div class="table__column">
          {{ item.typeLoad ? item.typeLoad : '-' }}
        </div>
        <div class="table__column">
          <div class="table__icon-wrapper">
            <i class="icon icon-clock-18px mr-2"></i>
            {{ item.execTime ? item.execTime : '-' }}
          </div>
        </div>
        <div class="table__column">
          <div class="table__icon-wrapper">
            <i class="icon icon-calendar-14px mr-2"></i>
            <p
              v-tooltip="{
                theme: 'default',
                content: `${item.exportDate ? $_rawDate(item.exportDate) : '-'}`,
                html: true,
                distance: 8,
              }"
            >
              {{ item.exportDate ? $_formatDate(item.exportDate) : '-' }}
            </p>
          </div>
        </div>
        <div class="table__column text-right">
          {{ item.processedCount ? $_formatTotalCount(item.processedCount) : '-' }}
        </div>
        <div class="table__column text-right">
          {{ item.size ? $_resolveValueUnit(item) : '-' }}
        </div>
        <menu-dropdown
          class="table__column table__dropdown"
          :label="item.id"
          :actions="actionsDropdown(item, modalId)"
        />
      </div>
    </div>
    <modal-dialog-question
      :id="modalId"
      :delete-action="triggerAction"
      :is-visible="isVisible"
      @closeDialogModal="isVisible = $event"
      :message="$t('integrations.do-you-want-continue')"
    />
    <base-loader v-show="$_verifyLoadedVuex('loading')" />
    <info-card v-show="$_verifyLoadedVuex('info')" ref="message-error" :error="getHasError" />
  </div>
</template>

<script>
// libs
import bus from '@/helpers/events/bus';
import { mapState, mapGetters, mapActions } from 'vuex';
import { getRunExport } from '@/services/integrations';
import { useToast } from 'vue-toastification';
// helpers
import { historyMixin, tableMixin, valueUnitMixin, verifyMixin } from '@/helpers/mixins';
import { openLightbox } from '@/helpers/lightbox';
// components
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner';
import InfoCard from '@/components/_atoms/InfoCard';
import MenuDropdown from '@/components/_atoms/MenuDropdown.vue';
import ModalDialogQuestion from '@/components/_atoms/ModalDialogQuestion';

export default {
  name: 'HistoryImportTable',
  components: {
    BaseLoader,
    InfoCard,
    ModalDialogQuestion,
    MenuDropdown,
  },
  mixins: [historyMixin, tableMixin, valueUnitMixin, verifyMixin],
  setup() {
    const toast = useToast();

    return { toast };
  },
  data() {
    return {
      order: null,
      orderType: 'asc',
      isActive: '',
      tableData: null,
      modalId: 'connector-import',
      logId: null,
      isCancelRecurrenceModalActive: false,
      isVisible: false,
    };
  },
  computed: {
    ...mapState('historyImport', ['historyData', 'historySerie', 'loadingGlobal', 'isEmptyGlobal', 'hasErrorGlobal']),
    ...mapGetters('historyImport', [
      'getFilteredHistoryList',
      'getHistoryData',
      'getIsEmpty',
      'getHasError',
      'getLoading',
    ]),
  },
  beforeUpdate() {
    this.updateTable();
  },
  mounted() {
    this.resetSelected();
    this.getImportHistoryList();
    bus.$on('update-selected-brand', () => {
      this.callFunctionsBusOn();
    });
    bus.$on('render-cards', () => {
      this.callFunctionsBusOn();
    });
    bus.$on(`${this.modalId}-show-recurrence-confirm-modal`, logId => {
      this.isVisible = true;
      this.isCancelRecurrenceModalActive = true;
      this.logId = logId;
    });
    bus.$on(`${this.modalId}-show-new-payload-confirm-modal`, logId => {
      this.isVisible = true;
      this.logId = logId;
    });
    bus.$on(`${this.modalId}-open-connector-logs`, logId => {
      openLightbox('lightbox-history-import', { logId });
    });
  },
  beforeUnmount() {
    bus.$off(['update-selected-brand', 'render-cards']);
  },
  methods: {
    ...mapActions('historyImport', [
      'getImportHistoryList',
      'setPaginationOrder',
      'setCancelRecurrence',
      'resetSelected',
    ]),
    /**
     * @description Verify list order, filter and organize personas list
     */
    updateTable() {
      this.tableData = this.getHistoryData;
    },
    /**
     * @description Receive and send data for $_tableOrdination
     * @param {Object} data
     */
    ordenate(key) {
      // update internal table state with order type mixin
      const { order, orderType } = this.$_tableOrderType({
        key,
        order: this.order,
        orderType: this.orderType,
      });
      this.isActive = key;
      this.order = order;
      this.orderType = orderType;

      // increment key with desc to be sent by action
      const orderFormat = orderType === 'asc' ? key : `-${key}`;
      this.setPaginationOrder(orderFormat);
    },
    /**
     * @description fix alignment based on item key
     */
    resolveTextAlign(key) {
      let align;
      if (key === 'status') {
        align = 'text-center';
      }
      if (key === 'typeLoad' || key === 'execTime' || key === 'exportDate') {
        align = 'text-left';
      }
      if (key === 'processedCount' || key === 'size') {
        align = 'text-right d-flex justify-content-end align-items-center';
      }
      return align;
    },
    /**
     * @description fetch to request a new export
     */
    fetchRunNewPayload() {
      getRunExport({ logId: this.logId })
        .then(({ data }) => {
          if (!data.success) this.toast.error(this.$t('integrations.error-export'));
        })
        .then(() => this.getExportHistoryList());
    },
    /**
     * @description trigger import vuex action
     */
    triggerAction() {
      if (this.isCancelRecurrenceModalActive) this.setCancelRecurrence(this.logId);
      else this.fetchRunNewPayload();
      // reset modal type flag
      this.isCancelRecurrenceModalActive = false;
    },

    callFunctionsBusOn() {
      this.resetSelected();
      this.getImportHistoryList();
    },

    /**
     * @description actions to menu dropdown
     */
    openConnectorLogs(connector, modalId) {
      bus.$emit(`${modalId}-open-connector-logs`, connector.id);
    },
    actionsDropdown(connector, modalId) {
      return [
        {
          name: 'integrations.action.log',
          action: () => this.openConnectorLogs(connector, modalId),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  color: #555;
  font-size: 12px;
  height: auto;
  min-height: 630px;
  margin: 0;

  .table__header,
  .table__body {
    .table__row {
      display: grid;
      grid-template-rows: 55px;
      grid-template-columns: 20% 15% 15% 20% 10% 10% 10%;
      align-items: center;
    }
  }

  .table__header {
    font-weight: 600;
    margin-bottom: 12px;
    .table__row {
      padding: 0 10px;
    }
  }

  .table__body {
    .table__row {
      grid-template-columns: 20% 15% 15% 20% 10% 10% 10%;
      grid-auto-columns: 100px;
      padding: 0 10px;
      border-bottom: 1px solid #ddd;

      &:last-child {
        border-bottom: none;
      }

      .table__column {
        p {
          margin: unset;
        }
        .table__status-wrapper {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .table__recurrent {
            margin-left: 12px;
            min-width: 20px;
            img {
              cursor: pointer;
            }
          }
          .table__status-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 65%;
          }
        }
        &.table__dropdown {
          display: grid;
          grid-column: 7;
          justify-content: right;
          padding-right: 10px;
        }
        .table__icon-wrapper {
          display: flex;
          align-items: center;
          cursor: context-menu;

          .icon {
            font-size: 14px;
          }
        }
      }
    }
  }

  .table__status {
    display: inline-block;
    padding: 0 7px;
    font-weight: 600;
    line-height: 22px;
    border: 1px solid;
    border-radius: 5px;

    &--success {
      color: $oto-ecommerce;
      border-color: $oto-ecommerce;
    }
    &--error,
    &--cancelled {
      color: $color-red;
      border-color: $color-red;
    }
    &--running {
      color: $color-orange;
      border-color: $color-orange;
    }
    &--scheduled {
      color: $oto-omni;
      border-color: $oto-omni;
    }
  }

  .table__header-title {
    display: inline-block;
    width: fit-content;
    white-space: initial;
    margin-right: 5px;
  }

  .table__order-by {
    background-color: $gray-400;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    line-height: 100%;
    padding: 3px 0;
    height: 18px;
    width: 18px;
    min-width: 18px;
    text-align: center;

    .table__dash-arrows {
      display: block;
      color: $color-white;
      border: solid $gray-900;
      border-width: 0 1px 1px 0;
      border-radius: 0;
      display: inline-block;
      padding: 3px;
      transform: translate(0, -50%) rotate(45deg);

      &--asc {
        transform: translate(0, -50%) rotate(45deg);
      }
      &--desc {
        transform: rotate(-135deg);
      }
    }

    &--active {
      background-color: $oto-omni;

      .table__dash-arrows {
        border-color: $color-white;
      }

      .table__dash-arrows {
        &--asc {
          transform: translate(0, -50%) rotate(45deg);
        }
        &--desc {
          transform: rotate(-135deg);
        }
      }
    }
  }
}
</style>

<style lang="scss">
.tooltip.import-recurring,
.tooltip.import-connector {
  top: -5px !important;
  div.tooltip-inner {
    padding: 0px 15px !important;
    height: 35px !important;
    line-height: 35px !important;
  }
  div.arrow {
    left: 18px !important;
  }
}

.tooltip.import-recurring {
  left: 40px !important;
}
.tooltip.import-connector {
  left: 85px !important;
}
.tooltip.import.export-date {
  left: -60px !important;
}
</style>
